
function eotwJSXFactory(elementName, attributes) {
    let $element = $(document.createElement(elementName));
    if ("object" === typeof attributes && null !== attributes) {
        if ("undefined" !== typeof attributes["unsafehtml"]) {
            attributes["unsafeHtml"] = attributes["unsafehtml"];
            delete attributes["unsafehtml"];
        }

        if ("undefined" !== typeof attributes["unsafeHtml"]) {
            $element.html(attributes["unsafeHtml"]);
            delete attributes["unsafeHtml"];
        }

        if ("undefined" !== typeof attributes["className"]) {
            if ("string" !== typeof attributes["class"]) {
                attributes["class"] = "";
            }
            attributes["class"] = attributes["class"] + " " + attributes["className"];
            delete attributes["className"];
        }

        if ("undefined" !== typeof attributes["htmlFor"]) {
            attributes['for'] = attributes['htmlFor'];
            delete attributes['htmlFor'];
        }

        $element.attr(attributes);
    }

    if (arguments.length > 2) {
        for (let i = 2; i < arguments.length; i++) {
            handleChildren($element, arguments[i]);
        }
    }
    return $element;
}

function handleChildren($element, children) {
    if (children === null) return;
    if (Array.isArray(children)) {
        children.forEach(handleChildren.bind(this, $element));
    } else if ("string" === typeof children) {
        $element.append(document.createTextNode(children));
    } else {
        $element.append(children);
    }
}

export default eotwJSXFactory;
